import Vue from 'vue'
import Component from 'vue-class-component'
import { TabBarListTypeMap, TabTypeMap } from '../../utils/constant'

@Component({
})
export default class TabBar extends Vue {
  tabPrefix = this.$publicPath + 'images/video_editor/tabbar_'
  // 默认tab
  tabBarNameList = [{
    name: '封面',
    icon: 'cover',
    type: TabTypeMap.COVER
  }, {
    name: '字幕',
    icon: 'subtitles',
    type: TabTypeMap.SUBTITLES
  }, {
    name: '发音人',
    icon: 'speaker',
    type: TabTypeMap.SPEAKER
  }, {
    name: '音乐',
    icon: 'music',
    type: TabTypeMap.MUSIC
  }]
  // 文字模板 tab
  editTextTemplateList = [{
    name: '文字模板',
    icon: 'text-template',
    type: TabTypeMap.EDIT_TEXT_TEMPLATE
  }, {
    name: '删除',
    icon: 'delete',
    type: TabTypeMap.DELETE_TEXT_TEMPLATE
  }]
  // 编辑图片tab
  editImgBarNameList = [{
    name: '编辑图片',
    icon: 'edit',
    type: TabTypeMap.EDITIMG
  }]
  // 编辑配音tab
  editSpeakerBarNameList = [{
    name: '编辑配音',
    icon: 'edit',
    type: TabTypeMap.EDITSPEAKER
  }]
  // 编辑背景音tab
  editMusicList = [{
    name: '编辑背景音乐',
    icon: 'edit',
    type: TabTypeMap.MUSIC
  }, {
    name: '音量',
    icon: 'volume',
    type: TabTypeMap.VOLUME
  },{
    name: '删除',
    icon: 'delete',
    type: TabTypeMap.DELETEVOLUME
  }]
  // 编辑器字体
  editFontBarNamleList = [{
    name: '编辑',
    icon: 'edit',
    type: TabTypeMap.EDITFONT
  }, {
    name: '字体',
    icon: 'font',
    type: TabTypeMap.FONT
  }, {
    name: '样式',
    icon: 'style',
    type: TabTypeMap.STYLE
  }, {
    name: '文字发音',
    icon: 'wordpron',
    type: TabTypeMap.WORDPRON
  }, {
    name: '数字发音',
    icon: 'numpron',
    type: TabTypeMap.NUMPRON
  }]
  // tabBarListMap = {}
  currentTabBarTag = TabBarListTypeMap.DEFAULT
  params = null
  // tabbar标签列表Map
  get tabBarListMap() {
    const _tabBarListMap = {}
    const listName = [TabBarListTypeMap.DEFAULT, TabBarListTypeMap.TEXT_TEMPLATE, TabBarListTypeMap.IMG, TabBarListTypeMap.SPEAKER, TabBarListTypeMap.FONT,TabBarListTypeMap.BGMUSIC]
    listName.forEach((listName) => {
      let tabBarList = []
      this[listName].forEach((item, index) => {
        tabBarList.push({
          id: index,
          name: item.name,
          icon: this.tabPrefix + item.icon + '.png',
          type: item.type
        })
      })
      _tabBarListMap[listName] = tabBarList
    })
    return _tabBarListMap
  }
  /**
   * 切换tab数据
   * @param type
   * @param params 
   */
  changeTabList(params) {
    this.params = params.param
    this.params.index = params.index
    this.params.rcttsWordList = params.rcttsWordList
    // if (params.type !== TabBarListTypeMap.BGMUSIC) {
      this.currentTabBarTag = params.type
    // }
  }
  /**
   * 切换tab
   * @param tabInfo
   */
  changeTab(tabInfo) {
    this.$emit('change-tab', tabInfo.type, this.params)
  }
  /**
   * 返回初始菜单
   */
  backTabBar() {
    this.currentTabBarTag = TabBarListTypeMap.DEFAULT
  }
}